/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AnalysesTree/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Analyses from './Analyses/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AnalysesTree({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CephTracing/ViewTraces/Content/AnalysesTree"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Analyses'
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="AnalysesTree.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z20EU5T': dtColorsWhite,'--pl-2-Z20EU5T': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-3-Z20EU5T': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--brc-4-Z20EU5T': dtColorsNeutral400}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'Analyses'}>
<Analyses
  viewPath={`${viewPath}/Analyses`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}